import { AxiosInstance, AxiosResponse } from 'axios';
import { Auth } from '../state/auth/types';
import { get, patch, post } from '../hooks/useAxiosPrivate';
import { GroupSummary } from './homeApi';

const url = (auth: Auth | null) =>
  `/api/v1/company/${auth?.companyId}/child-companies`;

const GroupsApi = {
  // Groups are child companies of the current org.
  getGroups: async (
    axios: AxiosInstance,
    auth: Auth | null
  ): Promise<GroupSummary[]> => {
    const response: AxiosResponse<{ groups: GroupSummary[] }> = await get(
      axios,
      url(auth)
    );
    return response.data.groups;
  },
  createGroup: async (
    axios: AxiosInstance,
    auth: Auth | null,
    name: string,
    reason?: string
  ): Promise<{ _id: string; companyName: string }> => {
    const response: AxiosResponse<{ _id: string; companyName: string }> =
      await post(axios, url(auth), { name, ...(reason ? { reason } : {}) });
    return response.data;
  },
  updateGroup: async (
    axios: AxiosInstance,
    auth: Auth | null,
    groupId: string,
    name: string,
    isActive: boolean
  ): Promise<{
    _id: string;
    companyName: string;
    active: boolean;
  }> => {
    const response: AxiosResponse<{
      _id: string;
      companyName: string;
      active: boolean;
    }> = await patch(axios, `${url(auth)}/${groupId}`, {
      name,
      active: isActive,
    });
    return response.data;
  },
  assignFieldPersonnel: async (
    axios: AxiosInstance,
    auth: Auth | null,
    groupId: string,
    fieldPersonnelId: string | null
  ): Promise<{ success: string }> => {
    const response: AxiosResponse<{ success: string }> = await patch(
      axios,
      `${url(auth)}/${groupId}/assign-field-personnel`,
      { assignedFieldPersonnelId: fieldPersonnelId }
    );
    return response.data;
  },
};

export default GroupsApi;
